<div class="flex justify-between items-center">
  <h1 class="mb-6">Set up an agreement</h1>
  <sbnb-close (click)="close()"></sbnb-close>
</div>
<hospitable-statements-commissions-form
  (agreementChange)="updateCommission($event)"
  [showProperties]="false"
  (formValid)="formValid = $event"></hospitable-statements-commissions-form>
<div class="flex items-center mt-4 gap-4 justify-end">
  <sbnb-button type="secondary" (clicked)="close()" [disabled]="saving$ | async">Cancel</sbnb-button>
  <sbnb-button (clicked)="save()" [disabled]="saving$ | async">Create</sbnb-button>
</div>
